<template>
    <div class="m-5 min-h-3xl">
        <h1 class="text-5xl font-extrabold tracking-tight bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text"
            style="-webkit-text-fill-color: transparent;">Colors make the world beautiful</h1>


        <div class="flex w-full">
            <div v-if="colorData" class="m-5">
                <div>Tailwind</div>
                <color-wheel chart-id="twColorWheel" :chart-data="colorData"></color-wheel>
            </div>

            <div v-if="bootstrapChartData" class="m-5">
                <div>Bootstrap</div>
                <color-wheel chart-id="bsColorWheel" :chart-data="bootstrapChartData"></color-wheel>
            </div>
        </div>

    </div>
</template>

<script>
import TailwindColors from '../../assets/tailwind-colors'
import ColorWheel from "./ColorWheel.vue";
import ColorUtil from "../../app/utils/ColorUtil";
import BootstrapColors from '../../assets/bootstrap-colors.json'

export default {
    name: 'ColorsHome',
    components: {ColorWheel},
    computed: {
        bootstrapColors() {
            return Object.keys(this.bootstrapColorData).filter((color) => {
                return color !== 'gray'
            })
        },
    },
    data() {
        return {
            viewModel: {},
            tailwindColorData: TailwindColors,
            colorData: null,
            bootstrapChartData: null,
            bootstrapColorData: BootstrapColors,
        }
    },
    mounted() {
        let colorUtil = new ColorUtil()
        let colorList = colorUtil.tailwindBrightColors()
        let chartData = []

        console.log('Tw colors')
        for(let i = 0; i < colorList.length; i++ ) {
            let colorLabel = colorList[i]
            // console.log(colorLabel)
            let hexValue = this.tailwindColorData[colorLabel][500]
            chartData.push({name: colorLabel, value: 1, colorValue: hexValue})
        }

        this.colorData = chartData

        let bsChartData = []

        console.log('Bs colors')
        for(let i = 0; i < this.bootstrapColors.length; i++ ) {
            let colorLabel = this.bootstrapColors[i]
            // console.log(colorLabel)
            let hexValue = this.tailwindColorData[colorLabel][500]
            bsChartData.push({name: colorLabel, value: 1, colorValue: hexValue})
        }

        this.bootstrapChartData = bsChartData

        console.log('Tint and shade test')
        let blueHexColor = this.tailwindColorData['blue'][500]
        console.log('Blue 500 value: ' + blueHexColor)
        let hexValue = blueHexColor.substring(1)
        console.log(colorUtil.lighten(hexValue, 90) + ' TW color: ' + this.tailwindColorData['blue'][50] )
        console.log(colorUtil.lighten(hexValue, 80) + ' TW color: ' + this.tailwindColorData['blue'][100] )
        console.log(colorUtil.lighten(hexValue, 60) + ' TW color: ' + this.tailwindColorData['blue'][200] )
        console.log(colorUtil.lighten(hexValue, 40) + ' TW color: ' + this.tailwindColorData['blue'][300] )
        console.log(colorUtil.lighten(hexValue, 20) + ' TW color: ' + this.tailwindColorData['blue'][400] )

        console.log(colorUtil.darken(hexValue, 20) + ' TW color: ' + this.tailwindColorData['blue'][600] )
        console.log(colorUtil.darken(hexValue, 40) + ' TW color: ' + this.tailwindColorData['blue'][700] )
        console.log(colorUtil.darken(hexValue, 60) + ' TW color: ' + this.tailwindColorData['blue'][800] )
        console.log(colorUtil.darken(hexValue, 80) + ' TW color: ' + this.tailwindColorData['blue'][900] )
        console.log(colorUtil.darken(hexValue, 95) + ' TW color: ' + this.tailwindColorData['blue'][950] )
    },
    methods: {
        methodHere() {
        }
    }
}
</script>
